export const fmtINR = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  const num = typeof n === "string" ? parseFloat(n) : n;
  if (isNaN(num)) return "—";
  return new Intl.NumberFormat("en-IN", {
    style: "currency", currency: "INR", maximumFractionDigits: 0,
  }).format(num);
};

export const fmtNumber = (n) => {
  if (n === null || n === undefined) return "0";
  return new Intl.NumberFormat("en-IN").format(n);
};

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    }).format(new Date(d));
  } catch { return d; }
};


export const fmtCurrency = (amount, currencyCode = "INR") => {
  if (amount == null || isNaN(amount)) return "—";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 0, // change to 2 if you want to show decimals like .00
  }).format(amount);
};

